import axios from 'axios';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import type Document from '../../Document';
import { getDatadogLogger } from '@storebrand-digital/common-datadog';

export async function fetchContractNumbers() {
  return axios
    .get('/customer/document/archive/documents/contract-numbers')
    .then(({ data }) => data.payload)
    .catch((e) => {
      getDatadogLogger().error('Failed to fetch contract numbers', {}, e);
    });
}

export default function useContractNumbers() {
  return useQuery<Document.ContractNumber[]>({
    queryKey: ['documents', 'contract-numbers'],
    queryFn: fetchContractNumbers,
    placeholderData: keepPreviousData,
    staleTime: 1000 * 60 * 5, // 5 minutes
    refetchInterval: 1000 * 60 * 60,
  });
}
